import { render, staticRenderFns } from "./error-placeholder.vue?vue&type=template&id=10d35a75&"
import script from "./error-placeholder.vue?vue&type=script&lang=js&"
export * from "./error-placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports